import React from 'react'

export default function NoRecord() {
  return (
    <div className="is-size-6 is-italic" style={{ textAlign: "center", padding: "20px", color: "grey" }}>No Record Found</div>
  )
}
